import { Gender, Language } from '@app/shared/types/common';

export interface TotalUsers {
  ok: boolean;
  total: number;
  totalGiftedItems?: number | null;
}

export enum UserRole {
  USER = 'user',
  SUPER = 'super',
}

export interface CurrentUser {
  id: number;
  telegramUsername: string | null;
  role: UserRole;
  referrerId: number;
  language: string;
  autoPurchase: boolean;
}

export interface UpdateLanguagePayload {
  language: Language;
}

export interface CurrentUserProfile {
  userId: number;
  fullName: string | null;
  instagramTag: string | null;
  bio: string | null;
  country: string | null;
  city: string | null;
  activitiesScope: string | null;
  avatar: string | null;
  birthday: string | null;
  gender: Gender | null;
  telegramUsername: string | null;
  showSuperPower: boolean | null;
  superPower: SuperPower | null;
  feedPandaNtf: boolean;
  refUsersCount: number;
  curator: {
    userId: string | null;
    fullName: string | null;
    telegramUsername: string | null;
  };
  firstStoneRewardClaimed: boolean;
  isUserAgreementRead: boolean;
  isTutorialCompleted: boolean;
}

export interface WithAutoPurchase {
  autoPurchase: boolean;
}

export type CurrentUserProfileFormState = Omit<
  CurrentUserProfile,
  | 'userId'
  | 'curator'
  | 'avatar'
  | 'firstStoneRewardClaimed'
  | 'refUsersCount'
  | 'superPower'
  | 'showSuperPower'
> &
  WithAutoPurchase;

export interface CurrentUserProfileUpdatePayload {
  fullName?: string | null;
  instagramTag?: string | null;
  bio?: string | null;
  country?: string | null;
  city?: string | null;
  activitiesScope?: string | null;
  avatar?: string | null;
  birthday?: string | null;
  gender?: string | null;
  showSuperPower?: boolean | null;
  feedPandaNtf?: boolean;
  isUserAgreementRead?: boolean;
  isTutorialCompleted?: boolean;
}

export interface SuperPower {
  data: string;
  title: string;
}

export interface SendGiftBody {
  to: number; //not sure why "to", represents the quantity of gifts
  action: GiftType;
  nodeLevel: number;
  maxWaiting?: number; //will return if wasn't take in minutes, default 3600
  balance: 'ton' | 'cookie';
}

export interface SendGiftResponse {
  giftToken: string;
}

export interface ClaimWheelBody {
  reward_type: WheelRewardType;
}

export enum WheelRewardType {
  COOKIE_200 = 'cookie_200',
  TENT = 'tent',
  COOKIE_100 = 'cookie_100',
  TENT_UPGRADE = 'tent_upgrade',
  YEAR_FORECAST = 'year_forecast',
  COOKIE_10 = 'cookie_10',
  DIAMOND_1 = 'diamond_1',
  COOKIE_20 = 'cookie_20',
  DIAMOND_2 = 'diamond_2',
  COOKIE_50 = 'cookie_50',
  LAND = 'land',
  CARD_OF_DAY = 'card_of_day',
}

export interface SpinWheelResponse {
  rewardType?: WheelRewardType;
  rewardAmount?: number;
  spinAt?: string;
  previousSpinAt?: string;
  cardId?: string;
}

export type GiftType = 'SETTLEMENT' | 'STONE';

export interface ClaimMediaRewardBody {
  activityId: number;
  settlementId: number;
}

export interface PracticeRewardData {
  cookiesAwarded: number;
  xpAwarded: number;
  showModal: boolean;
  completionCount: number;
}

export interface UpdateUserAutoPurchasePayload {
  autoPurchase: boolean;
}

export interface UpdateUserFeedPandaNtfPayload {
  feedPandaNtf: boolean;
}

export enum UsersTagType {
  CURRENT_USER = 'CurrentUser',
  CURRENT_USER_PROFILE = 'CurrentUserProfile',
  BALANCE_HISTORY = 'BalanceHistory',
}
